import React, { useState } from "react"
import InfoIcon from "@/public/icons/info.svg"
import { addDataLayer } from "../ProductDetailView/analytics"

import ToolTip from "@/components/core/ToolTip/ToolTip"

const SkuInfo = props => {
  const [priceListTooltip, setpriceListTooltip] = useState(false)
  const {
    price,
    sku,
    description,
    skulabel,
    listlabel,
    authorData,
    productInfo,
  } = props

  const priceListTooltipHandler = data => {
    setpriceListTooltip(true)
    addDataLayer({
      title: "list info mouseover",
      isDetailsTab: true,
      productInfo,
      toolTipProps: {
        isToolTip: true,
        toolTipValue: data?.toLowerCase(),
      },
    })
  }

  return (
    <div className="skuinfo-row">
      <div className="skuinfo-text">
        <p className="note">
          <span className="label">{skulabel}</span> :{" "}
          <span className="sku">{sku}</span>
        </p>
        {description && <p className="customNotes">{description}</p>}
      </div>
      <div className="skuprice-info price-list">
        <span className="list-label">
          <span className="">{listlabel}</span>
          <img
            src={InfoIcon?.src}
            role="tooltip"
            tabIndex={0}
            onMouseOver={() =>
              priceListTooltipHandler(authorData.priceListTooltip)
            }
            onMouseLeave={() => setpriceListTooltip(false)}
            className="price-listTooltipIcon"
          />
          <span className="price-list__price">{price && `$${price}`}</span>
          <div
            className={`price-list__list-tooltip${
              priceListTooltip ? "--show" : "--hide"
            }`}
          >
            {authorData?.priceListTooltip && (
              <div className="price-list__list-tooltip-wrapper">
                <ToolTip message={authorData.priceListTooltip} />
              </div>
            )}
          </div>
        </span>
      </div>
    </div>
  )
}

export default SkuInfo
